import React from "react";
import { motion } from "framer-motion";
import { FaPills, FaBoxes, FaExclamationTriangle } from "react-icons/fa";

const MedicineStatsCards = ({ medicines = [], report = [] }) => {
  const totalMedicines = medicines.length;
  const totalStock = medicines.reduce((s, m) => s + (m.stock || 0), 0);
  const lowStock = medicines.filter(
    (m) => (m.lowStockLimit ?? 10) >= (m.stock ?? 0)
  ).length;

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="row g-3">
      {/* Total Medicines */}
      <div className="col-sm-6 col-md-4">
        <motion.div
          variants={cardVariants}
          initial="hidden"
          animate="show"
          transition={{ duration: 0.4 }}
          whileHover={{ scale: 1.03 }}
          className="stat-card-pro"
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6>Total Medicines</h6>
              <h2>{totalMedicines}</h2>
            </div>
            <div className="icon-box bg-primary">
              <FaPills />
            </div>
          </div>
        </motion.div>
      </div>

      {/* Total Stock */}
      <div className="col-sm-6 col-md-4">
        <motion.div
          variants={cardVariants}
          initial="hidden"
          animate="show"
          transition={{ duration: 0.4, delay: 0.1 }}
          whileHover={{ scale: 1.03 }}
          className="stat-card-pro"
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6>Total Stock</h6>
              <h2>{totalStock}</h2>
            </div>
            <div className="icon-box bg-success">
              <FaBoxes />
            </div>
          </div>
        </motion.div>
      </div>

      {/* Low Stock */}
      <div className="col-sm-6 col-md-4">
        <motion.div
          variants={cardVariants}
          initial="hidden"
          animate="show"
          transition={{ duration: 0.4, delay: 0.2 }}
          whileHover={{ scale: 1.03 }}
          className="stat-card-pro"
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6>Low Stock Alerts</h6>
              <h2 className={lowStock > 0 ? "text-danger" : ""}>{lowStock}</h2>
            </div>
            <div className="icon-box bg-danger">
              <FaExclamationTriangle />
            </div>
          </div>
        </motion.div>
      </div>

      {/* STYLES */}
      <style>{`
        .stat-card-pro {
          background: white;
          border-radius: 14px;
          padding: 22px;
          box-shadow: 0 10px 22px rgba(0,0,0,0.08);
          transition: all 0.2s ease-in-out;
          cursor: pointer;
        }

        .stat-card-pro h6 {
          font-size: 14px;
          color: #6c757d;
          margin: 0;
          font-weight: 600;
          letter-spacing: 0.3px;
        }

        .stat-card-pro h2 {
          margin-top: 5px;
          font-weight: 700;
          color: #0d6efd;
          font-size: 32px;
        }

        .icon-box {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 22px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.15);
        }
      `}</style>
    </div>
  );
};

export default MedicineStatsCards;
